import { isEqual } from "lodash";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import * as URI from "urijs";

export interface IQuery {
    [key: string]: string[] | string | undefined;
}

interface QueryStringFiltersOwnProps<TFilter, TQuery> {
    filter: TFilter;
    getQuery: (filter: TFilter) => TQuery;
    getFilter: (query: TQuery) => TFilter;
    onFilterChange: (filter: TFilter) => void;
}

export type QueryStringFiltersProps<TFilter, TQuery> = QueryStringFiltersOwnProps<TFilter, TQuery> & RouteComponentProps<any>;

class QueryStringFiltersInternal<TFilter extends object, TQuery extends IQuery> extends React.Component<QueryStringFiltersProps<TFilter, TQuery>> {
    constructor(props: QueryStringFiltersProps<TFilter, TQuery>) {
        super(props);

        if (props.location.search) {
            this.updateFiltersFromQueryString(props.location.search);
        }
    }

    public componentWillReceiveProps(props: QueryStringFiltersProps<TFilter, TQuery>) {
        if (!isEqual(props.filter, this.props.filter)) {
            this.updateQueryStringFromFilters(props.filter);
            return;
        }

        if (props.location.search !== this.props.location.search) {
            this.updateFiltersFromQueryString(props.location.search);
        }
    }

    public render(): string {
        return null;
    }

    private updateQueryStringFromFilters(filter: TFilter) {
        const query = this.props.getQuery(filter);
        const queryString = convertQueryToQueryString(query);

        if (this.props.location.search !== queryString) {
            const location = {...this.props.history, search: queryString};
            this.props.history.replace(location);
        }
    }

    private updateFiltersFromQueryString(queryString: string) {
        const query = URI(queryString).search(true);
        const filter = this.props.getFilter(query);
        if (!isEqual(filter, this.props.filter)) {
            this.props.onFilterChange(filter);
        }
    }
}

export function convertQueryToQueryString<TQuery extends IQuery>(query: TQuery): string {
    const normalisedQuery = normaliseQuery(query);
    return new URI().search(normalisedQuery as object).search();
}

export function normaliseQuery<TQuery extends IQuery>(query: TQuery): { [key in keyof TQuery]?: string[] | string | undefined } {
    const normalisedQuery: { [key in keyof TQuery]?: string[] | string | undefined } = {};
    for (const key in query) {
        if (!query.hasOwnProperty(key)) {
            continue;
        }

        const value = query[key];

        normalisedQuery[key] = value instanceof Array
            ? value.length ? value : undefined
            : value || undefined;
    }

    return normalisedQuery;
}

export class QueryStringFilters<TFilter extends object, TQuery extends IQuery>
    extends (withRouter(class extends QueryStringFiltersInternal<TFilter, TQuery> {})) {
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/QueryStringFilters/QueryStringFilters.tsx